/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable @next/next/no-img-element */
import { Box, Chip, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import React from 'react';
import { SeatClassType } from '@/containers/SearchFlightTab/ChooseSeatClass/type';
import { TSelectedDate } from '@/slices/calendar';
import { IFlightDataMappingSegments } from '@/utils/flightCardMapping';
import { mappingFullDate } from '@/utils/timeMapping';
import { renderDuration } from '@/utils/renderDuration';
import { mappingTextFromSeatClass, mappingTextFromSeatClassCode } from '@/utils/seatClassMapping';
import FlexRowBetween from '../FlexRowBetween';
import FlexRowCenter from '../FlexRowCenter';
import DashPoints from '@/components/DashPoints';
import { pr } from '@/utils/pxToRem';
// import { isDesktop } from 'react-device-detect';
import { style } from '@/styles/globals';
import { useAppSelector } from '@/utils/hook';

interface TripCardDetailContentProps {
  segmentData: IFlightDataMappingSegments;
  isRoundTrip: boolean;
  isDesktop?: boolean;
  isTransit?: boolean;
  isDepart?: boolean;
  isHideDateHeader?: boolean;
  isReturn?: boolean;
  canExpanded?: boolean;
  isExpanded: boolean;
  onExpandChange?: (status: boolean) => void;
  selectedDate: any;
  seatClass?: SeatClassType;
  seatClassText?: string;
  stops?: number;
  cabin: string;
  startTerminal?: string;
  endTerminal?: string;
}

const TripCardDetailContent: React.FC<TripCardDetailContentProps> = ({
  isDepart,
  isReturn,
  isRoundTrip,
  segmentData,
  canExpanded,
  onExpandChange,
  isHideDateHeader,
  seatClass,
  selectedDate,
  isExpanded,
  stops,
  seatClassText,
  isDesktop,
  cabin,
  startTerminal,
  endTerminal,
}) => {
  const fareConfig = useAppSelector((state) => state.fareRule.fareConfig);
  const {
    departureAirportName,
    departureTime,
    arrivalAirportName,
    arrivalTime,
    airlineName,
    airlineCode,
    duration,
    arrivalCity,
    departureCity,
    operatingAirline,
    dayChange,
    startTime,
  } = segmentData;
  return (
    <Container spacing={pr`18px`}>
      <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="baseline"
        spacing="0.5rem"
      >
        {isRoundTrip && !isHideDateHeader && (
          <Chip
            sx={{
              borderRadius: (theme) => theme.palette?.borderRadius?.badge,
              backgroundColor: (theme) => theme.palette?.blue4,
            }}
            label={
              isDepart ? (
                <Typography
                  color="blue2"
                  fontWeight="500"
                  variant="captionMedium"
                >
                  Chiều đi
                </Typography>
              ) : isReturn ? (
                <Typography
                  color="blue2"
                  fontWeight="500"
                  variant="captionMedium"
                >
                  Chiều về
                </Typography>
              ) : (
                ''
              )
            }
          />
        )}
        {!isHideDateHeader && selectedDate && (
          <Typography variant="contentRegular">
            {mappingFullDate(startTime || '')}
            <Typography
              mx={({ palette }) => palette.xSmall}
              variant="contentRegular"
            >
              |
            </Typography>
            <Typography variant="contentRegular">
              {segmentData.class && mappingTextFromSeatClassCode(segmentData.class, segmentData.operatingAirline, fareConfig, cabin)}
              {/* {seatClassText && seatClassText} */}
            </Typography>
          </Typography>
        )}
      </Stack>
      <FlexRowBetween
        sx={{
          alignItems: 'baseline',
          position: 'relative',
        }}
      >
        <Stack
          spacing={0.3}
          style={{ width: '5.5em' }}
        >
          <Typography
            variant="title"
          >
            {departureTime}
          </Typography>
          {!isDesktop && (
            <Typography
              variant="contentRegular"
              style={{ whiteSpace: 'nowrap' }}
            >
              {departureCity}
              {/* {startTerminal && ` T${startTerminal}`} */}
            </Typography>

          )}
        </Stack>

        <DashPoints
          isDesktop={isDesktop}
          stops={stops}
          time={
            typeof duration === 'number' ? renderDuration(duration) : duration
          }
        />

        <Stack
          sx={{
            textAlign: 'right',
            width: '5.5em',
          }}
          spacing={0.3}
        >
          <Stack
            sx={{ position: 'relative' }}
            direction="row"
            justifyContent="flex-end"
          >
            <Typography
              variant="title"
            >
              {arrivalTime}
            </Typography>
            {!!dayChange
              && (
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: '10px',
                    color: style.color.blue3,
                    whiteSpace: 'nowrap',
                    height: '16px',
                    ...(isDesktop && {
                      position: 'absolute',
                      bottom: '20px',
                      width: '100%',
                      textAlign: 'right',
                    }),
                  }}
                >
                  +
                  {' '}
                  {dayChange}
                  {' '}
                  ngày
                </Typography>
              )}
          </Stack>
          {!isDesktop && (
            <Typography
              variant="contentRegular"
              style={{ whiteSpace: 'nowrap' }}
            >
              {arrivalCity}
            </Typography>
          )}
        </Stack>
      </FlexRowBetween>
      <FlexRowBetween style={{ marginTop: isDesktop ? '-1.5em' : 0 }}>
        <Typography
          variant="caption"
          style={{ maxWidth: '11.5em' }}
        >
          {departureAirportName}
          {startTerminal && (
            <Box
              component="span"
              sx={{ color: Number(startTerminal) === 3 ? '#12A8A6' : 'inherit' }}
            >
                {` Ga T${startTerminal}`}
            </Box>
          )}
        </Typography>
        <Typography
          variant="captionRegular"
          style={{ maxWidth: '11.5em' }}
        >
          {arrivalAirportName}
          {endTerminal && (
            <Box
              component="span"
              sx={{ color: Number(endTerminal) === 3 ? '#12A8A6' : 'inherit' }}
            >
              {` Ga T${endTerminal}`}
            </Box>
          )}
        </Typography>
      </FlexRowBetween>
      <FlexRowBetween>
        <FlexRowCenter>
          <div
            style={{
              height: 25,
              marginRight: pr`8px`,
            }}
          >
            <img
              src={`https://storage.googleapis.com/goyolo-uat/images/airlines/${airlineCode.toLowerCase() || 'vn'
              }.png`}
              alt=""
              width="24"
              height="24"
              style={{
                borderRadius: '50%',
              }}
              className="lazyload"
            />
          </div>
          <Typography
            variant="caption"
            color="text.primary"
          >
            {airlineName}
          </Typography>
        </FlexRowCenter>

        {canExpanded && (
          <Typography
            fontSize="14px"
            fontWeight={500}
            variant="captionMedium"
            color={(theme) => theme.palette.product3}
            onClick={() => {
              setTimeout(() => {
                onExpandChange?.(!isExpanded);
              }, 0);
            }}
            sx={{ textDecoration: 'underline' }}
          >
            {isExpanded ? VN.COLLAPSE : VN.EXPAND}
          </Typography>
        )}
      </FlexRowBetween>
      {(operatingAirline === 'BL' || operatingAirline === '0V') && (
        <Typography
          ml="2px"
          mt="2px!important"
          variant="captionRegular"
          sx={{
            fontSize: '12px',
            fontWeight: 400,
            color: `${style.color.black4}`,
          }}
        >
          Khai thác bởi
          {' '}
          <span style={{ color: style.color.blue2 }}>
            {' '}
            {operatingAirline === 'BL' ? 'Pacific Airlines' : 'Vasco'}
            {' '}
          </span>
        </Typography>
      )}
    </Container>
  );
};

const Container = styled(Stack)(({ theme }) => ({
  background: theme.palette.white,
  borderRadius: 8,
}));

enum VN {
  EXPAND = 'Chi tiết',
  COLLAPSE = 'Thu gọn',
}

export default React.memo(TripCardDetailContent);
